import { Action, createAction, handleActions } from "redux-actions";
import { queueMessage } from "~shared/snackbarsProvider/actions";
import { GetPolizaResponse, PatchImpresosPolizaRequest } from "~api/types";
import {
  DetallePolizaState,
  Dispatch,
  GetState,
  ImpresoSeleccionado,
  Services,
} from "../types";

const setInitialState = createAction("SET_DETALLE_POLIZA_INITIAL_STATE");

const setCurrentPoliza = createAction(
  "SET_CURRENT_USUARIO",
  (currentPoliza: GetPolizaResponse | null) => ({
    currentPoliza,
  })
);

const getPolizaInited = createAction("OBTENER_POLIZA_INITED");

const getPolizaCompleted = createAction(
  "OBTENER_POLIZA_COMPLETED",
  (currentPoliza: GetPolizaResponse) => ({ currentPoliza })
);

const getPolizaFailed = createAction(
  "OBTENER_POLIZA_FAILED",
  (error: unknown) => ({
    error,
  })
);

const setPolizaFileName = createAction(
  "SET_POLIZA_FILENAME",
  (polizaFileNameSelected: ImpresoSeleccionado) => ({
    polizaFileNameSelected,
  })
);
const setTarjetaFileName = createAction(
  "SET_TARJETA_FILENAME",
  (tarjetaFileNameSelected: ImpresoSeleccionado) => ({
    tarjetaFileNameSelected,
  })
);

const setCedulaMercosurFileName = createAction(
  "SET_CEDULA_MERCOSUR_FILENAME",
  (cedulaMercosurFileNameSelected: ImpresoSeleccionado) => ({
    cedulaMercosurFileNameSelected,
  })
);

const setCuponeraFileName = createAction(
  "SET_CUPONERA_FILENAME",
  (cuponeraFileNameSelected: ImpresoSeleccionado) => ({
    cuponeraFileNameSelected,
  })
);

const getPoliza = (id: string) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(getPolizaInited());

      const response = await services.api.polizas().getPoliza(id);

      dispatch(getPolizaCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getPolizaFailed(error));
    }
  };
};

const patchPolizaInited = createAction("UPDATE_POLIZA_INITED");
const patchPolizaCompleted = createAction(
  "UPDATE_POLIZA_COMPLETED",
  (response: Response) => {}
);
const patchPolizaFailed = createAction(
  "UPDATE_POLIZA_FAILED",
  (error: unknown) => ({
    error,
  })
);

const patchPoliza = (polizaId: string, data: PatchImpresosPolizaRequest) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(patchPolizaInited());

      const response = await services.api.polizas().patchPoliza(polizaId, data);

      dispatch(patchPolizaCompleted(response));
      dispatch(queueMessage("Póliza actualizada correctamente", "success"));
    } catch (error) {
      console.error(error);
      dispatch(patchPolizaFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al actualizar la póliza. Intente nuevamente."
        )
      );
    }
  };
};

const detallePolizaInitialState: DetallePolizaState = {
  currentPoliza: null,
  isLoading: false,
  failed: false,

  polizaFileNameSelected: "",
  tarjetaFileNameSelected: "",
  cedulaMercosurFileNameSelected: "",
  cuponeraFileNameSelected: "",
  polizaActualizada: false,
};

const detallePolizaReducer = handleActions<DetallePolizaState, any>(
  {
    [setInitialState.toString()]: (
      state: DetallePolizaState
    ): DetallePolizaState => {
      return {
        ...detallePolizaInitialState,
        take: state.take,
        polizas: null,
      };
    },
    // El payload propio trae `currentPoliza`, así que el campo queda
    // undefined. Lo llenan usuarios y novedades, que despachan el mismo type.
    [setCurrentPoliza.toString()]: (
      state: DetallePolizaState,
      action: Action<any>
    ): DetallePolizaState => {
      return {
        ...state,
        currentUsuario: action.payload.currentUsuario,
      };
    },
    [getPolizaInited.toString()]: (): DetallePolizaState => {
      return {
        ...detallePolizaInitialState,
      };
    },
    [getPolizaCompleted.toString()]: (
      state: DetallePolizaState,
      action: Action<{ currentPoliza: GetPolizaResponse }>
    ): DetallePolizaState => {
      return {
        ...state,
        currentPoliza: action.payload.currentPoliza,
        isLoading: false,
        failed: false,
      };
    },
    [getPolizaFailed.toString()]: (
      state: DetallePolizaState
    ): DetallePolizaState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
    [setPolizaFileName.toString()]: (
      state: DetallePolizaState,
      action: Action<{ polizaFileNameSelected: ImpresoSeleccionado }>
    ): DetallePolizaState => {
      return {
        ...state,
        polizaFileNameSelected: action.payload.polizaFileNameSelected,
      };
    },
    [setTarjetaFileName.toString()]: (
      state: DetallePolizaState,
      action: Action<{ tarjetaFileNameSelected: ImpresoSeleccionado }>
    ): DetallePolizaState => {
      return {
        ...state,
        tarjetaFileNameSelected: action.payload.tarjetaFileNameSelected,
      };
    },
    [setCedulaMercosurFileName.toString()]: (
      state: DetallePolizaState,
      action: Action<{ cedulaMercosurFileNameSelected: ImpresoSeleccionado }>
    ): DetallePolizaState => {
      return {
        ...state,
        cedulaMercosurFileNameSelected:
          action.payload.cedulaMercosurFileNameSelected,
      };
    },
    [setCuponeraFileName.toString()]: (
      state: DetallePolizaState,
      action: Action<{ cuponeraFileNameSelected: ImpresoSeleccionado }>
    ): DetallePolizaState => {
      return {
        ...state,
        cuponeraFileNameSelected: action.payload.cuponeraFileNameSelected,
      };
    },
    [patchPolizaInited.toString()]: (
      state: DetallePolizaState
    ): DetallePolizaState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [patchPolizaCompleted.toString()]: (
      state: DetallePolizaState
    ): DetallePolizaState => {
      return {
        ...state,
        polizaActualizada: true,
        isLoading: false,
      };
    },
    [patchPolizaFailed.toString()]: (
      state: DetallePolizaState
    ): DetallePolizaState => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },

  detallePolizaInitialState
);

export { detallePolizaReducer };
export {
  getPoliza,
  setInitialState,
  setCurrentPoliza,
  patchPoliza,
  setPolizaFileName,
  setTarjetaFileName,
  setCedulaMercosurFileName,
  setCuponeraFileName,
};
